import { SubscriptionOrderStatus } from 'types';

export const SUBSCRIPTION_STATUSES_MAP: { [Key in SubscriptionOrderStatus]: string } = {
  CREATED: 'Awaiting paymnet',
  CANCELLED: 'Failed',
  ARCHIVED: 'Archived',
  PAID: 'Paid',
};
